export default __webpack_public_path__ + "static/media/HMS.54c0e919.jpg";